'use strict'

import GMaps from './GMaps'
import gpsImage from '@/assets/icons/icn-user-gps.svg'
import pinImage from '@/assets/icons/icn-local-pin.svg'
import carImage from '@/assets/img/car.png'

const config = {
  originMarkerImage: pinImage,
  destinytMarkerImage: pinImage,
  gpsMarkerImage: gpsImage,
  drivertMarkerImage: carImage,
  clientMarkerImage: gpsImage
}

export default {
  install (Vue) {
    Vue.$gmaps = new GMaps(config)
    Vue.prototype.$gmaps = new GMaps(config)
  }
}
